import { TFunction } from 'i18next';

import { getAttributeValueLabel } from 'companySettings/components/PartFinderAttributeValues/utils';
import { AttributeType } from 'companySettings/enums';
import { IPartFinderAttributeChanges, IPartFinderAttributeValue } from 'companySettings/types';

const MAX_LISTED_VALUES = 5;

const listValues = (type: AttributeType, values: IPartFinderAttributeValue[], t: TFunction) => {
  const labels = values.map((value) => getAttributeValueLabel(type, value, t));

  return labels.length > MAX_LISTED_VALUES
    ? `${labels.slice(0, MAX_LISTED_VALUES).join(', ')}, …`
    : labels.join(', ');
};

// One line for what a save or a version changed, e.g. "Renamed from … · Added 2 values: …".
// A save that changed nothing only published the draft.
export const formatAttributeChanges = (
  type: AttributeType,
  changes: IPartFinderAttributeChanges,
  t: TFunction,
  isPublish = false
) => {
  if (changes?.created) {
    return t('labelPartFinderAttributeCreated', { count: changes.added?.length ?? 0 });
  }

  const parts = [
    changes?.name && t('labelPartFinderAttributeRenamed', changes.name),
    changes?.added?.length > 0 &&
      t('labelPartFinderAttributeValuesAdded', {
        count: changes.added.length,
        values: listValues(type, changes.added, t),
      }),
    changes?.removed?.length > 0 &&
      t('labelPartFinderAttributeValuesRemoved', {
        count: changes.removed.length,
        values: listValues(type, changes.removed, t),
      }),
    changes?.changed?.length > 0 &&
      t('labelPartFinderAttributeValuesChanged', {
        count: changes.changed.length,
        values: listValues(
          type,
          changes.changed.map((change) => change.to),
          t
        ),
      }),
    changes?.reordered && t('labelPartFinderAttributeValuesReordered'),
  ].filter(Boolean);

  if (parts.length) {
    return parts.join(' · ');
  }

  return isPublish ? t('labelPartFinderAttributePublished') : t('labelNoChanges');
};
